export default __webpack_public_path__ + "6c90db0191b09471fc6f82eeae3dd265.svg";